import { useAuth, scopeFromRole } from "@/contexts/AuthContext";
import type { RoleKey } from "@/shared/lib/rbac";
import { AppSidebar } from "@/widgets/AppSidebar";
import { TenantShellNav } from "./TenantShellNav";

/**
 * 左侧导航按 scope 分叉:**租户端 → 74px 图标轨 + 上下文面板**(TenantShellNav);
 * **平台超管 → 沿用 AppSidebar 平台树**(§3「平台树保留不动」)。代客态 effectiveScope=TENANT 自然走新壳。
 */
export function AppNav() {
  const { permissions, user } = useAuth();
  const role = ((permissions?.role as RoleKey | undefined) ?? user?.role) as RoleKey | undefined;
  const scope = role ? scopeFromRole(role) : user?.scope;
  // OEM W3:渠道管理员(PARTNER)也走 AppSidebar(partnerTree)。
  return scope === "PLATFORM" || scope === "PARTNER" ? <AppSidebar /> : <TenantShellNav />;
}
